export default __webpack_public_path__ + "static/media/1744.d3bd05f0.png";